module.exports = __webpack_public_path__ + "media/images/favicons/favicon-sunday-21cfe686ae6071e3d7adde6db90fca18.ico";